var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({directives:[{name:"ripple",rawName:"v-ripple"}],class:_vm.containerClass,attrs:{"type":"button"}},_vm.$listeners),[_c('span',{staticClass:"p-paginator-icon pi pi-angle-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }